import React from 'react'
import { Modal, Button } from 'antd'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import moment from 'moment'

const EventPreviewModal = ({ visible, onCancel, events }) => {
  const columnDefs = [
    {
      headerName: 'Event Type',
      field: 'eventType',
      width: 150,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Cause Code',
      field: 'causeCode',
      width: 150,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Start Time',
      field: 'startTime',
      width: 200,
      valueFormatter: params =>
        params.value ? moment(params.value).format('MM/DD/YYYY HH:mm') : '',
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'End Time',
      field: 'endTime',
      width: 200,
      valueFormatter: params =>
        params.value ? moment(params.value).format('MM/DD/YYYY HH:mm') : '',
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Avg Derate',
      field: 'avgDerate',
      width: 150,
      valueFormatter: params => (params.value ? params.value.toFixed(2) : ''),
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: 'Description',
      field: 'causeCodeDescription',
      width: 300,
    },
    {
      headerName: 'Comments',
      field: 'comments',
      width: 300,
    },
  ]

  return (
    <Modal
      visible={visible}
      title="Preview Events"
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          Close
        </Button>,
      ]}
      width="80vw"
      zIndex={1002}
    >
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={events}
          defaultColDef={{
            resizable: true,
            sortable: true,
            filter: true,
          }}
        />
      </div>
    </Modal>
  )
}

export default EventPreviewModal
